import {
  Bookmark,
  BrainCircuit,
  FileText,
  StickyNote,
  type LucideIcon,
} from "lucide-react"
import type {
  DashboardActivity,
  DashboardActivityTone,
  DashboardActivityType,
} from "../types"
import type { StudentDashboardActivity } from "../../../../api/studentDashboard"
import {
  STUDENT_PRACTICE_PAPERS_PATH,
  studentPracticePaperHref,
} from "../../../../component/student/config/studentNavItems"

const ICON_BY_TYPE: Record<string, LucideIcon> = {
  paper_marked: BrainCircuit,
  paper_in_progress: FileText,
  paper_abandoned: FileText,
  paper_submitted: FileText,
  paper_generated: FileText,
  bookmark_added: Bookmark,
  note_saved: StickyNote,
}

const TONES: DashboardActivityTone[] = [
  "primary",
  "blue",
  "emerald",
  "red",
  "amber",
]

const toTone = (value?: string): DashboardActivityTone =>
  TONES.includes(value as DashboardActivityTone)
    ? (value as DashboardActivityTone)
    : "blue"

const activityHref = (item: StudentDashboardActivity) => {
  if (item.resourceType === "practice_paper" && item.resourceId) {
    return studentPracticePaperHref(item.resourceId)
  }
  return item.href || STUDENT_PRACTICE_PAPERS_PATH
}

export const mapDashboardActivity = (
  item: StudentDashboardActivity
): DashboardActivity => ({
  id: item.id,
  type: (item.type || "paper_generated") as DashboardActivityType,
  title: item.title,
  desc: item.description || "",
  time: item.occurredAt || "",
  icon: ICON_BY_TYPE[item.type] || FileText,
  tone: toTone(item.tone),
  to: activityHref(item),
})

